import parseISO from 'date-fns/parseISO';

import type { Schedule } from '@shared/types/schedules';

export const isBusyNow = (busy?: Schedule) => {
	if (!busy) return false;
	const { start_time, end_time } = busy;
	const start = parseISO(start_time);
	const end = parseISO(end_time);

	const current = new Date();
	return start <= current && current <= end;
};

export const isConfirmed = (busy?: Schedule) => {
	if (!busy) return false;
	return busy.payment_status === 'success' && !busy.changing_time_process.flag;
};
